/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevTerminalIcon16Light = forwardRef('DevTerminalIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.646 5.146a.5.5 0 0 1 .708 0L6 6.793a1 1 0 0 1 0 1.414L4.354 9.854a.5.5 0 0 1-.708-.708L5.293 7.5 3.646 5.854a.5.5 0 0 1 0-.708Z" }),
        React.createElement("path", { d: "M7.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.5A2.5 2.5 0 0 1 3.5 2h8A2.5 2.5 0 0 1 14 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 1 10.5v-6ZM3.5 3A1.5 1.5 0 0 0 2 4.5v6A1.5 1.5 0 0 0 3.5 12h8a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 11.5 3h-8Z" })));
});
